import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './v1/redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './v1/App';

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);
